import { Card } from "antd";
import { ClipboardCheck, Calendar, Trophy } from "lucide-react";
import { useSelector } from "react-redux";

export default function WorkSummaryCard() {
  const { data: workStats } = useSelector((state) => state.timeCard.workStats);

  const statsData = [
    {
      label: "Hours Worked",
      value: `${workStats?.totalWorkHours} hr/s`,
      sub: "This Month",
      icon: <ClipboardCheck className="w-4 h-4" />,
    },
    {
      label: "Days Present",
      value: `${workStats?.daysPresent}/${workStats?.workdaysScheduled}`,
      sub: `${workStats?.attendancePercent}% Attendance`,
      icon: <Calendar className="w-4 h-4" />,
    },
    {
      label: "Avg. Hours/Day",
      value: `${workStats?.avgHoursPerDay} hr/s`,
      sub: "Expected: 8 hrs",
      icon: <ClipboardCheck className="w-4 h-4" />,
    },
    {
      label: "On-Time %",
      value: `${workStats?.onTimePercent}%`,
      sub: `${workStats?.onTimeDays}/${workStats?.daysPresent} days`,
      icon: <Trophy className="w-4 h-4" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((item) => (
        <Card
          key={item.id}
          className={`flex flex-col gap-6 rounded-xl card-border-s ${
            item.label
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-") 
              .replace(/^-+|-+$/g, "")
          }`}
        >
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs card-text">{item.label}</p>
            <div className="card-text">{item.icon}</div>
          </div>

          <p className="text-2xl font-bold card-text">{item.value}</p>

          <p className="text-xs text-muted-foreground dark:text-zinc-500 mt-1 card-text">
            {item.sub}
          </p>
        </Card>
      ))}
    </div>
  );
}
